export enum Version {
  STRING = '6.0.0',
}

// imports
import { environment } from 'src/environments/environment'

export enum Themes {
  LIGHT = 'light-theme',
  DARK = 'dark-theme',
  PAPER = 'paper-theme',
}

export enum LocalStorageVariables {
  THEME = 'u_t',
  TOKEN = 'token',
  ACTIVISION_CODE = 'activision_code',
  EMAIL = 'email',
  USERNAME = 'username',
}

export enum URLs {
  BASE_LOCAL = 'http://localhost:8888/server',
  TEST_LOCAL = 'http://localhost:8888/server_tests/',

  //TODO: find out the path of hostinger(and port?)
  BASE_HOSTINGER = '*',
  TEST_HOSTINGER = '*/test',
}

export enum Files {
  W_P_D = 'http://localhost:8888/server/w_p_d.php',
  ADMIN = 'http://localhost:8888/server/admin.php',
  AUTH = 'http://localhost:8888/server/auth.php',
  BASE = 'http://localhost:8888/server/base.php',
  DB = 'http://localhost:8888/server/db.php',
  EMAIL_SENDER = 'http://localhost:8888/server/email_sender.php',
  JWT = 'http://localhost:8888/server/jwt.php',
  USER = 'http://localhost:8888/server/user.php',
  SHARED = 'http://localhost:8888/server/shared.php',
}

export enum Cookies {
  ACCESS_TOKEN = 'ddc_a_tk',
  REFRESH_TOKEN = 'ddc_r_tk',
}

//ng build -> environment.ts VS ng build --prod -> environment.prod.ts
// Connection to Backend (Angular->Host->Django)
export const Backend = {
  //Base URL
  // HOST_CONTAINER = "https://192.168.0.170:8000/",
  // HOST_CONTAINER = "https://localhost:8000/",
  // add environment.apiUrl from prod
  // HOST_CONTAINER = "https://localhost:8000/",

  //ng build -> environment.ts VS ng build --prod -> environment.prod.ts
  HOST_CONTAINER: environment.apiUrl,

  // ! Verification
  REGISTER_AND_SEND_VERIFICATION_CODE: 'verification/register/',
  VERIFY_VERIFICATION_CODE: 'verification/verify_code/',
  SEND_RESET_PASSWORD_EMAIL: 'verification/send_reset_p_link/',
  RESET_PASSWORD: 'verification/reset_password/',

  // ! Check
  CHECK_USERNAME_EMAIL_GET_USERNAME: 'check/username_email/get_username/',
  CHECK_USERNAME_EMAIL_GET_EMAIL: 'check/username_email/get_email/',

  // ! Authorization
  LOGIN: 'authorization/token/',
  REFRESH_TOKEN: 'authorization/token/refresh/',
  SIGN_OUT: 'authorization/token/clear/',
  IS_LOGGED_IN: 'ddc/is_logged_in/',

  // ! User Info
  USER_NAVBAR_INFO: 'ddc/user_navbar_info/',
  COMMON_INFO: 'ddc/common_info/',
  USER_HOME_ITEMS: 'ddc/home/followed_items/',
  USER_PROFILE: 'ddc/profile/',
  PUBLIC_USER_INFO: 'ddc/users/',
  UPDATE_USER_PROFILE_PIC: 'ddc/profile_pic/',

  // ! Data
  CATEGORY: 'ddc/categories/',
  TAG: 'ddc/tags/',

  WORD: 'ddc/words/',
  PAIR: 'ddc/pairs/',
  WORD_PAIR_DIC: 'ddc/words-pairs-dic/',

  DIC: 'ddc/dics/',
  ADD_WORDS_TO_DIC: 'add_words/',
  ADD_PAIRS_TO_DIC: 'add_pairs/',
  EDIT_DICS: 'edit_dics/',
  REMOVE_WORDS_FROM_DIC: 'remove_words/',
  REMOVE_PAIRS_FROM_DIC: 'remove_pairs/',

  NOTE: 'ddc/notes/',
  FIGURE: 'ddc/figure/',
  QUIZ: 'ddc/quiz/',
  CANVAS: 'ddc/canvas/',

  FOLLOWERS: 'ddc/relationships/followers/',
  FOLLOWING: 'ddc/relationships/following/',
  FOLLOW_COMMAND: 'ddc/relationships/command/',
  RELATIONSHIP_SEARCH: 'ddc/relationships/search/',

  OVERVIEW: 'ddc/overview/',
  LIKES: 'ddc/like/',
  BOOKMARKS: 'ddc/bookmark/',
  BOOKMARK_GROUPS: 'ddc/bookmark-groups/',
  COLLECTIONS: 'ddc/collections/',
  ALL_COLLS: 'all_items/',
  COLL_ITEMS: 'coll_items/',

  // ! Search
  FILTER: 'ddc/filter/search/',

  // ! Play
  PLAY: 'ddc/play/',
  PLAY_WEAK_POINTS: 'ddc/play/weak_points/',

  // ! Account
  ACCOUNT: 'ddc/account/',

  // ! Subscription
  SUBSCRIPTION: 'ddc/subscription/',

  // ! Admin Panel
  ADMIN_VERIFY_CODE: 'core/admin/verify-code/',
  ADMIN_VALIDATE_SESSION: 'core/admin/validate-session/',
  ADMIN_DASHBOARD: 'core/admin/dashboard/',
  ADMIN_USERS: 'core/admin/users/',
  ADMIN_LOGOUT: 'core/admin/logout/',

  // ! ADMIN AI
  ADMIN_AI_GENERATE: 'ai/generate/',
  ADMIN_AI_UPDATE_INDEX: 'ai/update-ai-index/',
  ADMIN_AI_ASSIGN_TO_USER: 'ai/assign-to-user/',
  ADMIN_AI_GET_CSV_FILES_LIST: 'ai/get-csv-files-list/',
  ADMIN_AI_GET_DICS: 'ai/get-dics/',
  ADMIN_AI_DELETE_DIC: 'ai/delete-dic/',

  // ! PDF Export
  PDF: 'ddc/pdf/',

  // ! Notifications
  NOTIFICATIONS: 'notifications/',
  NOTIFICATIONS_MARK_AS_READ: 'mark_all_read/',

  // ! Lingo AI
  AI_CHAT: 'api/ai/chat/',
  AI_HISTORY: 'api/ai/history/',
  AI_STATUS: 'api/ai/status/',
  AI_IMPROVE_CONTENT: 'api/ai/improve-content/',
  AI_ATTACHMENT_IMAGE: 'api/ai/attachment-upload-image/',

  // ! Explore^
  ACADEMY_DICTIONARIES: 'ddc/academy/dictionaries/',
  LOVE_DICTIONARIES: 'ddc/love/',
  DRIVING_LICENSE_DICTIONARIES: 'ddc/driving-license/',
}

export const Media = {
  // /ddc-angular-app/src/assets is mounted to /ddc-django-app/media
  ASSETS: environment.assetsPath,
  MEDIA: environment.mediaPath,
  EMPTY: '',
} as const

export enum CommonInfo {
  WELCOME = 'Welcome',
}

export enum Stages {
  SIGNED_UP = 1,
  FIRST_LOGIN = 2,
  SEEN_WELCOME = 3,
}

export const Languages = {
  ARABIC: ['Arabic', 'ARA'],
  AZERBAIJANI: ['Azerbaijani', 'AZE'],
  BENGALI: ['Bengali', 'BEN'],
  BULGARIAN: ['Bulgarian', 'BUL'],
  BURMESE: ['Burmese', 'BUR'],
  CROATIAN: ['Croatian', 'HRV'],
  CZECH: ['Czech', 'CZE'],
  DANISH: ['Danish', 'DAN'],
  GERMAN: ['Deutsch', 'DEU'],
  DUTCH: ['Dutch', 'DUT'],
  ENGLISH: ['English', 'ENG'],
  ESTONIAN: ['Estonian', 'EST'],
  FARSI: ['Farsi', 'FAS'],
  FINNISH: ['Finnish', 'FIN'],
  FRENCH: ['French', 'FRE'],
  GREEK: ['Greek', 'GRE'],
  HAUSA: ['Hausa', 'HAU'],
  HINDI: ['Hindi', 'HIN'],
  INDONESIAN: ['Indonesian', 'IND'],
  ITALIAN: ['Italian', 'ITA'],
  JAPANESE: ['Japanese', 'JPN'],
  JAVANESE: ['Javanese', 'JAV'],
  KOREAN: ['Korean', 'KOR'],
  LATVIAN: ['Latvian', 'LAV'],
  LITHUANIAN: ['Lithuanian', 'LIT'],
  MALAYALAM: ['Malayalam', 'MAL'],
  MALTESE: ['Maltese', 'MLT'],
  MANDARIN_CHINESE: ['Mandarin Chinese', 'MCH'],
  MARATHI: ['Marathi', 'MAR'],
  POLISH: ['Polish', 'POL'],
  PORTUGUESE: ['Portuguese', 'POR'],
  PUNJABI: ['Punjabi', 'PAN'],
  ROMANIAN: ['Romanian', 'RUM'],
  RUSSIAN: ['Russian', 'RUS'],
  SLOVAK: ['Slovak', 'SLO'],
  SLOVENIAN: ['Slovenian', 'SLV'],
  SPANISH: ['Spanish', 'SPA'],
  SWEDISH: ['Swedish', 'SWE'],
  TAMIL: ['Tamil', 'TAM'],
  TELUGU: ['Telugu', 'TEL'],
  THAI: ['Thai', 'THA'],
  TURKISH: ['Turkish', 'TUR'],
  UKRAINIAN: ['Ukrainian', 'UKR'],
  VIETNAMESE: ['Vietnamese', 'VIE'],
  WU_CHINESE: ['Wu Chinese', 'WCH'],
  YORUBA: ['Yoruba', 'YOR'],
  YUE_CHINESE: ['Yue Chinese', 'YCH'],
} as const

export const FlagIcons = {
  ARABIC: ['Arabic', 'fi-sa'],
  AZERBAIJANI: ['Azerbaijani', 'fi-az'],
  BENGALI: ['Bengali', 'fi-bd'],
  BULGARIAN: ['Bulgarian', 'fi-bg'],
  BURMESE: ['Burmese', 'fi-mm'],
  CROATIAN: ['Croatian', 'fi-hr'],
  CZECH: ['Czech', 'fi-cz'],
  DANISH: ['Danish', 'fi-dk'],
  GERMAN: ['Deutsch', 'fi-de'],
  DUTCH: ['Dutch', 'fi-nl'],
  ENGLISH: ['English', 'fi-gb-eng'],
  ESTONIAN: ['Estonian', 'fi-ee'],
  FARSI: ['Farsi', 'fi-ir'],
  FINNISH: ['Finnish', 'fi-fi'],
  FRENCH: ['French', 'fi-fr'],
  GREEK: ['Greek', 'fi-gr'],
  HAUSA: ['Hausa', 'fi-ne'],
  HINDI: ['Hindi', 'fi-in'],
  INDONESIAN: ['Indonesian', 'fi-id'],
  ITALIAN: ['Italian', 'fi-it'],
  JAPANESE: ['Japanese', 'fi-jp'],
  JAVANESE: ['Javanese', 'fi-id'],
  KOREAN: ['Korean', 'fi-kr'],
  LATVIAN: ['Latvian', 'fi-lv'],
  LITHUANIAN: ['Lithuanian', 'fi-lt'],
  MALAYALAM: ['Malayalam', 'fi-in'],
  MALTESE: ['Maltese', 'fi-mt'],
  MANDARIN_CHINESE: ['Mandarin Chinese', 'fi-cn'],
  MARATHI: ['Marathi', 'fi-in'],
  POLISH: ['Polish', 'fi-pl'],
  PORTUGUESE: ['Portuguese', 'fi-pt'],
  PUNJABI: ['Punjabi', 'fi-pk'],
  ROMANIAN: ['Romanian', 'fi-ro'],
  RUSSIAN: ['Russian', 'fi-ru'],
  SLOVAK: ['Slovak', 'fi-sk'],
  SLOVENIAN: ['Slovenian', 'fi-si'],
  SPANISH: ['Spanish', 'fi-es'],
  SWEDISH: ['Swedish', 'fi-se'],
  TAMIL: ['Tamil', 'fi-in'],
  TELUGU: ['Telugu', 'fi-in'],
  THAI: ['Thai', 'fi-th'],
  TURKISH: ['Turkish', 'fi-tr'],
  UKRAINIAN: ['Ukrainian', 'fi-ua'],
  VIETNAMESE: ['Vietnamese', 'fi-vn'],
  WU_CHINESE: ['Wu Chinese', 'fi-cn'],
  YORUBA: ['Yoruba', 'fi-ng'],
  YUE_CHINESE: ['Yue Chinese', 'fi-cn'],
} as const

export type LanguageCode = (typeof Languages)[keyof typeof Languages][1]
export type LanguageName = (typeof Languages)[keyof typeof Languages][0]

export enum Article {
  THE = 'The',
  DER = 'Der',
  DAS = 'Das',
  DIE = 'Die',
  DEN = 'Den',
  DEM = 'Dem',
  DES = 'Des',
  LES = 'Les',
  L_ = "L'",
  LE = 'Le',
  LA = 'La',
  EL = 'El',
  LOS = 'Los',
  LAS = 'Las',
  IL = 'Il',
  I = 'I',
  LO = 'Lo',
  GLI = 'Gli',
  AL = 'ال',
  SE = 'Se',
  A = 'A',
  AZ = 'Az',
  AN = 'An',
  NA = 'Na',
  A_ = "A'", //! which language ?
}

export enum SearchTypes {
  ALL = 'All',
  WORD = 'Word',
  PAIR = 'Pair',
  DICTIONARY = 'Dictionary',
  USERS = 'User',
  NOTE = 'Note',
  QUIZ = 'Quiz',
  FIGURE = 'Figure',
}

export const ArticlesByLanguage: { [language: string]: Article[] } = {
  [Languages.ENGLISH[1]]: [Article.THE],
  [Languages.GERMAN[1]]: [Article.DER, Article.DIE, Article.DAS, Article.DEM, Article.DEN],
  [Languages.FRENCH[1]]: [Article.DES, Article.LES, Article.LE, Article.L_, Article.LA],
  [Languages.ITALIAN[1]]: [Article.IL, Article.LO, Article.GLI, Article.LA, Article.I, Article.LE],
  [Languages.SPANISH[1]]: [
    Article.EL,
    Article.LOS,
    Article.LAS,
    Article.LO,
    Article.SE,
    Article.LA,
  ],
  [Languages.ARABIC[1]]: [Article.AL],
  [Languages.PORTUGUESE[1]]: [Article.A],
  [Languages.AZERBAIJANI[1]]: [Article.AZ],
  [Languages.DANISH[1]]: [Article.DEN, Article.AN, Article.NA],
  [Languages.DUTCH[1]]: [Article.DEN, Article.NA],
  [Languages.CZECH[1]]: [Article.NA],
  // TODO add more
}

export enum PartOfSpeech {
  NOUN = 'Noun',
  PRO_NOUN = 'Pronoun',
  VERB = 'Verb',
  ADV = 'Adv',
  ADJ = 'Adj',
  PRE_POSITION = 'Prep',
  CONJUNCTION = 'Conj',
  INTERJECTION = 'Interj',
  ARTICLE = 'Art',
}

export enum DefAndExp {
  WITH_DEF = 'With Definition',
  WITH_EXP = 'With Example',
  WITH_BOTH = 'With Definition and Example',
}

export enum DefaultPagination {
  OBJECT_PER_PAGE = 10,
}

export enum LibraryChips {
  OVERVIEW = 1,
  WORDS = 2,
  PAIRS = 3,
  DICTIONARIES = 4,
  CATEGORIES = 5,
  TAGS = 6,
  FOLLOWERS = 7,
  FOLLOWING = 8,
  NOTES = 9,
  QUIZZES = 10,
  FIGURES = 11,
  PDFS = 12,
}

export enum ContentTypes {
  CAT = 7,
  DDC_USER = 9,
  TAG = 10,
  WORD = 11,
  PAIR = 12,
  DIC = 13,
  NOTE = 30,
  QUIZ = 32,
  FIGURE = 37,
}

export class DataSearchResult {
  id?: number
  type?: string
  label?: string
  info?: any // Can be different based on type
  time_since_creation?: string
}

// Specific info interfaces for different search result types
export interface WordSearchInfo {
  language?: string
  article?: string
  pos?: string
  definition?: string
  example?: string
  category?: string
  last_tag?: string
}

export interface PairSearchInfo {
  language_1?: string
  language_2?: string
  category_1?: string
  category_2?: string
  last_tag_1?: string
  last_tag_2?: string
}

export interface DictionarySearchInfo {
  owner?: string
  description?: string
  words_count?: number
  pairs_count?: number
}

export interface UserSearchInfo {
  profile_pic?: string
  username?: string
  bio?: string
  country?: string
  city?: string
  language_1?: string
  language_2?: string
  language_3?: string
}

export class UserSearchResult {
  username?: string
  info?: any
}

export const DDCTypes = {
  WORDS: ['Words', 'fiber_manual_record'],
  PAIRS: ['Pairs', 'fiber_smart_record'],
  DICS: ['Dictionaries', 'book'],
  CATS: ['Categories', 'category'],
  TAGS: ['Tags', 'tag'],
} as const

export enum SearchChips {
  ALL = 0,
  WORD = 1,
  PAIR = 2,
  DICTIONARY = 3,
  CATEGORY = 4,
  TAG = 5,
  USER = 6,
  NOTE = 7,
  QUIZ = 8,
  FIGURE = 9,
}

export enum UserLegalInfo {
  LAST_UPDATED = 'January 2026',
  TERMS_AND_CONDS = `
<p>
                <br><br>
                Welcome to Daydic! These Terms &amp; Conditions ("Terms") govern your use of the Daydic mobile application and services.
                <br><br>
                1. ACCEPTANCE OF TERMS
                <br><br>
                By accessing or using Daydic, you agree to be bound by these Terms and our Privacy Policy.
                <br><br>
                2. DESCRIPTION OF SERVICE
                <br><br>
                Daydic is a language learning platform that allows users to create, share, and discover dictionaries, words, and language pairs.
                <br><br>
                3. USER ACCOUNTS
                <br><br>
                - You must provide accurate information when creating an account<br>
                - You are responsible for maintaining the security of your account<br>
                - You must be at least 13 years old to use this service
                <br><br>
                4. USER CONTENT
                <br><br>
                - You retain ownership of content you create<br>
                - You grant Daydic a license to use, display, and distribute your content<br>
                - You are responsible for the content you post
                <br><br>
                5. PROHIBITED CONDUCT
                <br><br>
                You may not:<br>
                - Post harmful, offensive, or inappropriate content<br>
                - Violate any laws or regulations<br>
                - Interfere with the service's operation<br>
                - Impersonate others
                <br><br>
                6. INTELLECTUAL PROPERTY
                <br><br>
                Daydic and its content are protected by copyright and other intellectual property laws.
                <br><br>
                7. DISCLAIMER
                <br><br>
                The service is provided "as is" without warranties of any kind.
                <br><br>
                8. LIMITATION OF LIABILITY
                <br><br>
                Daydic shall not be liable for any indirect, incidental, or consequential damages.
                <br><br>
                9. TERMINATION
                <br><br>
                We may terminate or suspend your account at any time for violations of these Terms.
                <br><br>
                10. AI USAGE &amp; DISCLAIMER (LINGO AI)
                <br><br>
                Our service utilizes Lingo AI technology to provide advanced language features.<br>
                - AI-generated content is for informational purposes and may not be 100% accurate.<br>
                - You acknowledge that AI responses are automated and may occasionally produce incorrect or biased outputs.<br>
                - You agree to use AI features responsibly and not for generating harmful or illegal content.
                <br><br>
                11. CHANGES TO TERMS
                <br><br>
                We may update these Terms from time to time. Continued use constitutes acceptance of updated Terms.
                <br><br>
                Contact us at daydic.app@gmail.com for questions about these Terms.
                <br><br>
                Last updated: January 2026
            </p>
      `,
  PRIVACY_POLICY = `
      <p>
                <br><br>
                This Privacy Policy describes how Daydic collects, uses, and protects your information.
                <br><br>
                1. INFORMATION WE COLLECT
                <br><br>
                - Account information (name, email, username)<br>
                - Profile information you provide<br>
                - Content you create (dictionaries, words, pairs)<br>
                - Usage data and analytics
                <br><br>
                2. HOW WE USE YOUR INFORMATION
                <br><br>
                - To provide and improve our services<br>
                - To communicate with you<br>
                - To personalize your experience<br>
                - To ensure security and prevent fraud
                <br><br>
                3. INFORMATION SHARING
                <br><br>
                We do not sell your personal information. We may share information:<br>
                - With your consent<br>
                - To comply with legal obligations<br>
                - To protect our rights and safety
                <br><br>
                4. DATA SECURITY
                <br><br>
                We implement appropriate security measures to protect your information.
                <br><br>
                5. YOUR RIGHTS
                <br><br>
                You may:<br>
                - Access your personal information<br>
                - Update or correct your information<br>
                - Delete your account<br>
                - Control privacy settings
                <br><br>
                6. COOKIES AND TRACKING
                <br><br>
                We use cookies and similar technologies to improve your experience.
                <br><br>
                7. THIRD-PARTY SERVICES
                <br><br>
                Our app may contain links to third-party services with their own privacy policies.
                <br><br>
                8. CHILDREN'S PRIVACY
                <br><br>
                We do not knowingly collect information from children under 13.
                <br><br>
                9. INTERNATIONAL TRANSFERS
                <br><br>
                Your information may be transferred to countries outside your residence.
                <br><br>
                10. AI DATA PROCESSING (LINGO AI)
                <br><br>
                When using Lingo AI features, input data may be processed to generate responses.
                We ensure that data sent to AI services is handled securely and in accordance with this privacy policy.
                <br><br>
                11. CHANGES TO PRIVACY POLICY
                <br><br>
                We may update this policy and will notify you of significant changes.
                <br><br>
                Contact us at daydic.app@gmail.com for privacy-related questions.
                <br><br>
                Last updated: January 2026
            </p>
      `,
  COOKIE_POLICY = `
      <p>
                <br><br>
                This Cookie Policy explains how Daydic uses cookies and similar technologies.
                <br><br>
                1. WHAT ARE COOKIES
                <br><br>
                Cookies are small text files stored on your device that help us provide and improve our services.
                <br><br>
                2. TYPES OF COOKIES WE USE
                <br><br>
                Essential Cookies:<br>
                - Authentication tokens<br>
                - Session management<br>
                - Security features
                <br><br>
                Performance Cookies:<br>
                - Analytics and usage statistics<br>
                - Error tracking<br>
                - Performance monitoring
                <br><br>
                Functional Cookies:<br>
                - User preferences<br>
                - Language settings<br>
                - Theme preferences
                <br><br>
                3. HOW WE USE COOKIES
                <br><br>
                - To keep you logged in<br>
                - To remember your preferences<br>
                - To analyze how you use our app<br>
                - To improve our services
                <br><br>
                4. THIRD-PARTY COOKIES
                <br><br>
                We may use third-party services that set their own cookies:<br>
                - Analytics providers<br>
                - Crash reporting services<br>
                - Performance monitoring tools
                <br><br>
                5. MANAGING COOKIES
                <br><br>
                You can control cookies through:<br>
                - Your device settings<br>
                - Your app preferences<br>
                - Clearing app data
                <br><br>
                6. COOKIE RETENTION
                <br><br>
                - Session cookies are deleted when you close the app<br>
                - Persistent cookies remain until expired or manually deleted<br>
                - Authentication cookies are managed by our security system
                <br><br>
                7. UPDATES TO COOKIE POLICY
                <br><br>
                We may update this policy to reflect changes in our practices or technology.
                <br><br>
                For questions about our use of cookies, contact us at daydic.app@gmail.com.
                <br><br>
                Last updated: January 2026
            </p>

      `,
}

// enum of icon names
export enum DaydicTypesIconNames {
  PDF = 'print',
  WORD = 'fiber_manual_record',
  PAIR = 'fiber_smart_record',
  DICTIONARY = 'auto_stories',
  NOTE = 'text_snippet',
  QUIZ = 'question_answer',
  FIGURE = 'hub',
  CATEGORY = 'category',
  TAG = 'tag',
  OVERVIEW = 'grid_view',
  PERSON = 'person',
  ALL = 'select_all',
  FOLLOWERS = 'groups',
  FOLLOWING = 'person_add_alt_1',
  GAME = 'emoji_events',
  FLASHCARD = 'style',
}
